/* import __COLOCATED_TEMPLATE__ from './messenger.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();